var take = require('../take');

module.exports = function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_dropLast.js
// module id = 1490
// module chunks = 0